import React from 'react'
import SolidStarIcon from 'components/Luxkit/Icons/solid/SolidStarIcon'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import { TrustPilotLogo } from 'components/Common/TrustIndicators/TrustPilotLogo'

const CardContainer = styled(Group)`
  width: 75vw;

  ${mediaQueryUp.tablet} {
    width: ${rem(320)};
  }
`

export interface FiveStarReview {
  content: string;
  name: string;
  region?: string;
  source: 'trustpilot' | 'google';
}

function ReviewCard({
  content,
  name,
  region,
  source,
}: FiveStarReview): JSX.Element {
  return (
    <CardContainer direction="vertical" gap={16}>
      <Group direction="horizontal" gap={4}>
        <SolidStarIcon size="S" />
        <SolidStarIcon size="S" />
        <SolidStarIcon size="S" />
        <SolidStarIcon size="S" />
        <SolidStarIcon size="S" />
      </Group>
      <BodyText variant="large">{content}</BodyText>
      <Group direction="horizontal" verticalAlign="center" gap={8}>
        <BodyText variant="large" weight="bold">{name}{region && `, ${region}`}</BodyText>
        <BodyText variant="large" weight="bold">·</BodyText>
        {source == 'google' && <GoogleLongLogo width="54" height="18" /> }
        {source == 'trustpilot' && <TrustPilotLogo width="78" height="18" /> }
      </Group>
    </CardContainer>
  )
}

export default ReviewCard
